import { render, staticRenderFns } from "./LawLeaderDeptManage.vue?vue&type=template&id=a7bf42c2&"
import script from "./LawLeaderDeptManage.vue?vue&type=script&lang=js&"
export * from "./LawLeaderDeptManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports